import type { ReactNode } from 'react'
import { cn } from '@/internationalization/cn'

export interface EmptyStateProps {
  icon?: ReactNode
  title: string
  /** Say what to do next, not that there is nothing here — the user can see that. */
  description?: string
  action?: ReactNode
  secondaryAction?: ReactNode
  className?: string
  size?: 'sm' | 'md'
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  secondaryAction,
  className,
  size = 'md',
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center',
        size === 'md' ? 'px-6 py-14' : 'px-4 py-8',
        className,
      )}
    >
      {icon && (
        <span
          aria-hidden
          className="mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-surface-muted
            text-fg-subtle [&>svg]:h-5 [&>svg]:w-5"
        >
          {icon}
        </span>
      )}
      <h3 className="text-md font-semibold text-fg">{title}</h3>
      {description && <p className="mt-1 max-w-sm text-base text-fg-muted">{description}</p>}
      {(action || secondaryAction) && (
        <div className="mt-4 flex flex-wrap items-center justify-center gap-2">
          {action}
          {secondaryAction}
        </div>
      )}
    </div>
  )
}
